export default __webpack_public_path__ + "static/media/6.0742a9d0.jpg";